import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import { useUserDetails } from "../hooks/useAuthQueries"

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth()
  const { data: userDetails } = useUserDetails()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (
    userDetails?.data?.mustChangePassword &&
    location.pathname !== "/force-password-change"
  ) {
    return <Navigate to="/force-password-change" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
